import Vue from 'vue';
import Router from 'vue-router';

import Home from './views/Home.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import HomeComponent from '@/components/HomeComponent.vue';
import PrivacyPolicyComponent from '@/components/PrivacyPolicyComponent.vue';
import TermsConditionsComponent from '@/components/TermsConditionsComponent.vue';
import ContactComponent from '@/components/ContactComponent.vue';
import PageNotFoundComponent from '@/components/PageNotFoundComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/home',
      children: [
        {
          path: '/',
          component: HomeComponent,
        },
        {
          path: 'contact',
          component: ContactComponent,
        },
        {
          path: '404',
          component: PageNotFoundComponent,
        },
      ],
    },
    {
      path: '/policies',
      component: PrivacyPolicy,
      redirect: '/policies/privacy-policy',
      children: [
        {
          path: 'privacy-policy',
          component: PrivacyPolicyComponent,
        },
        {
          path: 'terms-and-conditions',
          component: TermsConditionsComponent,
        },
      ],
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});
